
import { Vue } from "vue-class-component";

export default class NotebookSlash extends Vue {}
